export class UmUserInfo {
    name: string;
    email: string;
    picture: string;
}
